import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import './TrialDemoCRM.css';
import crmImage1 from './assets/dashboard.png';
import crmImage2 from './assets/product.png';
import crmImage3 from './assets/purchase.png';
import crmImage4 from './assets/statement.png';

const TrialDemoCRM = () => {
  const handleTryForFree = () => {
    const phoneNumber = '+923162003961';
    const message = 'I want this demo for free';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="trial-demo-crm-wrapper">
      <div className="hero-section text-center">
        <h1>Unlock the Power of Our CRM Solution</h1>
        <p className="lead">Streamline your business with cutting-edge tools for customer management, sales, and analytics.</p>
      </div>
      <Container className="trial-demo-crm py-5">
        <Row className="justify-content-center">
          <Col xs={12} sm={6} md={3} className="mb-4">
            <Card className="crm-card">
              <Card.Img variant="top" src={crmImage1} alt="Dashboard" />
              <Card.Body>
                <Card.Title>Dashboard</Card.Title>
                <Card.Text>
                  Get a comprehensive overview of your business with our customizable dashboard.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-4">
            <Card className="crm-card">
              <Card.Img variant="top" src={crmImage2} alt="Product Management" />
              <Card.Body>
                <Card.Title>Product Management</Card.Title>
                <Card.Text>
                  Organize and manage your products efficiently with real-time inventory tracking.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-4">
            <Card className="crm-card">
              <Card.Img variant="top" src={crmImage3} alt="Purchase Tracking" />
              <Card.Body>
                <Card.Title>Purchase Tracking</Card.Title>
                <Card.Text>
                  Streamline your purchasing process with automated tracking and reporting.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-4">
            <Card className="crm-card">
              <Card.Img variant="top" src={crmImage4} alt="Financial Statements" />
              <Card.Body>
                <Card.Title>Financial Statements</Card.Title>
                <Card.Text>
                  Generate detailed financial reports to make informed business decisions.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <div className="text-center my-5">
          <Button
            variant="primary"
            size="lg"
            onClick={handleTryForFree}
            className="try-for-free-btn"
          >
            Try for Free
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default TrialDemoCRM;